import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

// Matches the interface defined in the component
interface OpenedOpportunity {
  opportunity_id: string;
  opportunity_name: string;
  account_id: string;
  account_name: string;
  created_date: string;
  hasPublishedMilestoneAnalysis: boolean;
}

const fetchRecentOpenedOpportunities = async (
  days: number,
  limit: number,
): Promise<OpenedOpportunity[]> => {
  const params = new URLSearchParams({
    days: days.toString(),
    limit: limit.toString(),
  });
  return api.get<OpenedOpportunity[]>(
    `/datahub/reporting/home/recent-opened-opportunities?${params}`, // Adjusted endpoint pattern
  );
};

export const useRecentOpenedOpportunities = (days: number, limit: number) => {
  return useQuery<OpenedOpportunity[], Error>({
    queryKey: ["recentOpenedOpportunities", days, limit],
    queryFn: () => fetchRecentOpenedOpportunities(days, limit),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
